import { useEffect, useState } from 'react';

import { send } from '@actual-app/core/platform/client/connection';

import { guardarEstadoBanca, leerEstadoBanca } from './estadoBanca';
import { useSyncServerStatus } from './useSyncServerStatus';

export function useEnableBankingStatus(enabled = true) {
  const ultimaRespuesta = leerEstadoBanca();
  const [configuredEnableBanking, setConfiguredEnableBanking] = useState<
    boolean | null
  >(ultimaRespuesta?.configured ?? null);
  // Rumbo (beta): el servidor dice si este usuario puede conectar bancos
  // (admin, ids de RUMBO_BANCA_USUARIOS o RUMBO_BANCA_PROBADORES=1).
  const [bancaPermitida, setBancaPermitida] = useState(
    ultimaRespuesta?.permitida ?? false,
  );
  const [isLoading, setIsLoading] = useState(ultimaRespuesta === null);
  const status = useSyncServerStatus();

  useEffect(() => {
    if (!enabled) return;

    async function fetch() {
      if (leerEstadoBanca() === null) {
        setIsLoading(true);
      }
      try {
        const results = await send('enablebanking-status');
        const respuesta = {
          configured: results.configured || false,
          permitida: results.permitida === true,
        };
        guardarEstadoBanca(respuesta);
        setConfiguredEnableBanking(respuesta.configured);
        setBancaPermitida(respuesta.permitida);
      } catch {
        guardarEstadoBanca(null);
        setConfiguredEnableBanking(false);
        setBancaPermitida(false);
      } finally {
        setIsLoading(false);
      }
    }

    if (status === 'online') {
      void fetch();
    }
  }, [status, enabled]);

  return {
    configuredEnableBanking,
    bancaPermitida,
    isLoading,
  };
}
